import React, { useContext, useEffect, useState } from "react"
import Context from "../utils/Context"
import api from "../api/api"
import { cancelActions } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faCircleExclamation, faCirclePause, faCircleMinus, faCircleStop, faCog } from '@fortawesome/free-solid-svg-icons'

export default function ListOrders(props) {
    const context = useContext(Context)

    const [monthNames, setMonthNames] = useState(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"])

    useEffect(() => {
        const fetcher = async () => {
            let uniqueRobots = []

            props.data.forEach(order => {
                if (!uniqueRobots.some(robot => robot === order.robotName)) uniqueRobots.push(order.robotName)
            })
        }

        fetcher()
    }, [props.data])

    const cancelOrder = (order, inProgress, nextOrder) => {
        if (inProgress) {
            if (context.isRobotConnected) {
                cancelActions({ stopAll: true })
            } else {
                context.mqttClient.publish('inspire/fms/' + order.robotName + '/cancel', JSON.stringify({ order: "stopAll" }), { qos: 0, retain: false }, (error) => {
                    if (error) {
                        console.error(error)
                    }
                })
            }
        }

        api.cancelOrders(order._id)
            .then(() => {
                props.cancelled(!props.cancelledValue)
            })
            .catch((e) => console.log(e))

        let position

        if (order.missionName.slice(0, 4) === 'Drop') position = order.missionName
        else position = nextOrder
        console.log(position)
        api.removeUsed(1, { position })
    }

    const verifyStatus = (order) => {
        let stateOrder

        if (order?.dtStarted) {
            stateOrder = "A executar"
        } else if (order?.dtReceived) {
            stateOrder = "Fila"
        } else {
            stateOrder = "À espera"
        }

        return stateOrder
    }

    const orders = props.data.sort((a, b) => b.value - a.value)

    return (
        <>
            <div className="table-container orders-list-table">
                <table className="table is-hoverable is-fullwidth is-size-7">
                    <thead>
                        <tr>
                            {props.headers.map((header, index) => (
                                <th className={`is-capitalized `} key={index}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {orders.map((order, index) => {
                            const dateStart =
                                order.dtStarted &&
                                monthNames[new Date(order.dtStarted).getMonth()] +
                                " " +
                                new Date(order.dtStarted).getDate()

                            const timeStart =
                                order.dtStarted && new Date(order.dtStarted).getHours() + ':' + new Date(order.dtStarted).getMinutes()

                            return (
                                <tr
                                    key={index}
                                    className="table-row"
                                >
                                    <td>
                                        <span>{order.missionName}</span>
                                    </td>

                                    <td>
                                        <span>{order.robotName}</span>
                                    </td>

                                    <td>
                                        {order.dtStarted ? (
                                            <span>
                                                {dateStart} {timeStart}
                                            </span>
                                        ) : (<span>-</span>)}
                                    </td>

                                    <td>
                                        <span className=" mr-2 ">
                                            {verifyStatus(order)}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="icon">
                                            {order.dtStarted ? (
                                                <button key={index} className="button is-danger is-light mr-3" onClick={() => cancelOrder(order, true, orders[index + 1]?.missionName)}>
                                                    <FontAwesomeIcon icon={faCog} className="fas fa-lg fa-pulse mr-2 ml-2" />
                                                </button>
                                            ) : order.dtReceived ? (
                                                <button key={index} className="button is-danger is-light mr-3" onClick={() => cancelOrder(order, false, orders[index + 1]?.missionName)}>
                                                    <FontAwesomeIcon icon={faBan} className="fas fa-lg  mr-2 ml-2" />

                                                </button>
                                            ) : (
                                                <button key={index} className="button is-info is-light mr-3" onClick={() => cancelOrder(order, false, orders[index + 1]?.missionName)}>
                                                    <FontAwesomeIcon icon={faBan} className="fas fa-lg  mr-2 ml-2" />
                                                </button>
                                            )}
                                        </span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                {(!props.data || (props.data && props.data.length <= 0)) &&
                    <div>
                        <span className="icon is-small">
                            <FontAwesomeIcon icon={faCircleExclamation} className="is-small mr-1" />
                        </span>

                        <span>Sem ordens!</span>
                    </div>
                }
            </div>
        </>
    )
}